'use strict';

const { Swiper } = require("swiper");
const BREAKPOINTS = require('../../../experience/breakpoints.json');
const CONFIG = require('./config.productFinder.json');

window.swiper = null;
window.hasSwiped = false;
window.swiper_currentStepName = '';
window.swiper_currentStep = '';
const createSwiper = () => {
    if (CONFIG.steps[window.swiper_currentStepName]?.hideSwiper) {
        $(window.swiper_currentStep).find('.swiper').addClass('swiper--hidden');
        $(window.swiper_currentStep).find('.swiper .fa').hide();
        return;
    }

    let settings = {
        slidesPerView: 'auto',

        a11y: false,

        centeredSlides: false,
        simulateTouch: true,

        initialSlide: 0,

        mousewheel: true,
        freeMode: true,

        spaceBetween: 8,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    };

    if (window.swiper_currentStepName === 'answerWithImageBkgrdAndDescription') {
        settings.centeredSlides = true;
        settings.initialSlide = parseInt($(window.swiper_currentStep).find('.step__answer').length / 2);
    } else if (window.swiper_currentStepName === 'recommendation') {
        settings.slidesPerView = $(':root').css('--nb-product-per-line');
        settings.breakpoints = {
            [BREAKPOINTS.mobile]: {
                slidesPerView: $(':root').css('--nb-product-per-line-sm'),
            },
            [BREAKPOINTS.tablet]: {
                slidesPerView: $(':root').css('--nb-product-per-line-md'),
            },
            [BREAKPOINTS.desktop]: {
                slidesPerView: $(':root').css('--nb-product-per-line-lg'),
            },
        };
        settings.mousewheel = false;
        settings.freeMode = false;
        settings.spaceBetween = 0;
    }

    if (!$('body').hasClass('mobile')) {
        if ($(window.swiper_currentStep).find('.swiper').length > 0) {
            $('.swiper, .swiper-wrapper').css('transform', 'none');
            setTimeout(function () {
                const currentStepSwiper = $(window.swiper_currentStep).find('.swiper')[0];

                if (window.swiper !== null) {
                    window.swiper.destroy();
                    window.swiper = null;
                }

                window.swiper = new Swiper(currentStepSwiper, settings);

                window.swiper.on('touchMove', function () {
                    window.hasSwiped = true;
                });
            }, 300);
        }
    } else if (window.swiper !== null) {
        window.swiper.destroy();
        window.swiper = null;

        $('.swiper, .swiper-wrapper').css('transform', 'none');
    }
};

$(document).on('mousedown touchstart', function () {
    window.hasSwiped = false;
});

module.exports = {
    createSwiper,
};

window.addEventListener('resize', createSwiper);
